import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b60b487e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=b60b487e&prod&lang=scss"
import style1 from "./index.vue?vue&type=style&index=1&id=b60b487e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b60b487e",
  null
  
)

export default component.exports